import type { PlanTableDTO } from '@mutations'
import { getRequest } from '../utils'

export const getPlanTables: RequestTypeVariable = {
  getKey: (projectGuid: string) => ['getPlanTables', projectGuid],
  /**
   * `storeys` resolves the template tables for the plan of these storeys, exactly like the plan
   * export does; without it the server falls back to each table's configured storeys.
   */
  request: async (projectGuid: string, storeys?: readonly string[]): Promise<PlanTableDTO[]> => {
    const params = storeys
      ? new URLSearchParams(storeys.map(storey => ['storeys', storey]))
      : undefined
    const { data } = await getRequest<PlanTableDTO[]>({
      url: `/projects/${projectGuid}/plan-tables`,
      params,
    })

    return data || []
  },
}
